import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-copy",
  "use": "foquz-icon-copy-usage",
  "viewBox": "0 0 19 21",
  "content": "<symbol viewBox=\"0 0 19 21\" fill=\"none\" id=\"foquz-icon-copy\"><path d=\"M1 10a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H3a2 2 0 01-2-2v-8z\" stroke=\"currentColor\" stroke-width=\"2\" /><path d=\"M10 0a3 3 0 00-3 3v2h2V3a1 1 0 011-1h6a1 1 0 011 1v8a1 1 0 01-1 1h-2v2h2a3 3 0 003-3V3a3 3 0 00-3-3h-6z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol